import { render, staticRenderFns } from "./GoodsOrder.vue?vue&type=template&id=6d62901e&scoped=true&"
import script from "./GoodsOrder.vue?vue&type=script&lang=js&"
export * from "./GoodsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62901e",
  null
  
)

export default component.exports